
export function selectUrlPdf(namePdf, arrayList) {
    const selectedPdf = arrayList.find(value => value.node.name === namePdf)

    return selectedPdf.node.publicURL
  }